module.exports = __webpack_public_path__ + "img/close.d3381d88.svg";